import React from 'react';
import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';

import { Description } from 'components/landing/components/description';
import { Content } from 'components/landing/components/content';
import teamMember from 'images/services/team-member.svg';

const dumbDemoForm = dumbBem('demo-form');
const TeamMemberIcon = tx([{ element: 'team-member-icon' }, dumbDemoForm])('img');

const Done = () => {
  return (
    <Content modifier="success">
      <TeamMemberIcon src={teamMember} alt="" />
      <Description>
        Thanks for getting in touch.<br />Our team will contact you shortly.
      </Description>
    </Content>
  );
};

export default Done;



// WEBPACK FOOTER //
// ./src/components/landing/components/demoForm/Done.js